import { useState } from "react";

// Pinned at the top for quick access
const POPULAR = [
  { c: "+354", l: "Iceland" },
  { c: "+55", l: "Brazil" },
  { c: "+1", l: "USA / Canada" },
  { c: "+44", l: "United Kingdom" },
  { c: "+49", l: "Germany" },
  { c: "+33", l: "France" },
  { c: "+34", l: "Spain" },
  { c: "+351", l: "Portugal" },
];

// Full world dialing codes (alphabetical by country)
const ALL = [
  { c: "+93", l: "Afghanistan" }, { c: "+355", l: "Albania" }, { c: "+213", l: "Algeria" },
  { c: "+376", l: "Andorra" }, { c: "+244", l: "Angola" }, { c: "+1", l: "Antigua & Barbuda" },
  { c: "+54", l: "Argentina" }, { c: "+374", l: "Armenia" }, { c: "+61", l: "Australia" },
  { c: "+43", l: "Austria" }, { c: "+994", l: "Azerbaijan" }, { c: "+1", l: "Bahamas" },
  { c: "+973", l: "Bahrain" }, { c: "+880", l: "Bangladesh" }, { c: "+1", l: "Barbados" },
  { c: "+375", l: "Belarus" }, { c: "+32", l: "Belgium" }, { c: "+501", l: "Belize" },
  { c: "+229", l: "Benin" }, { c: "+975", l: "Bhutan" }, { c: "+591", l: "Bolivia" },
  { c: "+387", l: "Bosnia & Herzegovina" }, { c: "+267", l: "Botswana" }, { c: "+55", l: "Brazil" },
  { c: "+673", l: "Brunei" }, { c: "+359", l: "Bulgaria" }, { c: "+226", l: "Burkina Faso" },
  { c: "+257", l: "Burundi" }, { c: "+855", l: "Cambodia" }, { c: "+237", l: "Cameroon" },
  { c: "+1", l: "Canada" }, { c: "+238", l: "Cape Verde" }, { c: "+236", l: "Central African Rep." },
  { c: "+235", l: "Chad" }, { c: "+56", l: "Chile" }, { c: "+86", l: "China" },
  { c: "+57", l: "Colombia" }, { c: "+269", l: "Comoros" }, { c: "+242", l: "Congo" },
  { c: "+243", l: "Congo (DRC)" }, { c: "+506", l: "Costa Rica" }, { c: "+385", l: "Croatia" },
  { c: "+53", l: "Cuba" }, { c: "+357", l: "Cyprus" }, { c: "+420", l: "Czechia" },
  { c: "+45", l: "Denmark" }, { c: "+253", l: "Djibouti" }, { c: "+1", l: "Dominican Republic" },
  { c: "+593", l: "Ecuador" }, { c: "+20", l: "Egypt" }, { c: "+503", l: "El Salvador" },
  { c: "+240", l: "Equatorial Guinea" }, { c: "+291", l: "Eritrea" }, { c: "+372", l: "Estonia" },
  { c: "+268", l: "Eswatini" }, { c: "+251", l: "Ethiopia" }, { c: "+298", l: "Faroe Islands" },
  { c: "+679", l: "Fiji" }, { c: "+358", l: "Finland" }, { c: "+33", l: "France" },
  { c: "+241", l: "Gabon" }, { c: "+220", l: "Gambia" }, { c: "+995", l: "Georgia" },
  { c: "+49", l: "Germany" }, { c: "+233", l: "Ghana" }, { c: "+30", l: "Greece" },
  { c: "+299", l: "Greenland" }, { c: "+502", l: "Guatemala" }, { c: "+224", l: "Guinea" },
  { c: "+592", l: "Guyana" }, { c: "+509", l: "Haiti" }, { c: "+504", l: "Honduras" },
  { c: "+852", l: "Hong Kong" }, { c: "+36", l: "Hungary" }, { c: "+354", l: "Iceland" },
  { c: "+91", l: "India" }, { c: "+62", l: "Indonesia" }, { c: "+98", l: "Iran" },
  { c: "+964", l: "Iraq" }, { c: "+353", l: "Ireland" }, { c: "+972", l: "Israel" },
  { c: "+39", l: "Italy" }, { c: "+225", l: "Ivory Coast" }, { c: "+1", l: "Jamaica" },
  { c: "+81", l: "Japan" }, { c: "+962", l: "Jordan" }, { c: "+7", l: "Kazakhstan" },
  { c: "+254", l: "Kenya" }, { c: "+965", l: "Kuwait" }, { c: "+996", l: "Kyrgyzstan" },
  { c: "+856", l: "Laos" }, { c: "+371", l: "Latvia" }, { c: "+961", l: "Lebanon" },
  { c: "+266", l: "Lesotho" }, { c: "+231", l: "Liberia" }, { c: "+218", l: "Libya" },
  { c: "+423", l: "Liechtenstein" }, { c: "+370", l: "Lithuania" }, { c: "+352", l: "Luxembourg" },
  { c: "+853", l: "Macau" }, { c: "+261", l: "Madagascar" }, { c: "+265", l: "Malawi" },
  { c: "+60", l: "Malaysia" }, { c: "+960", l: "Maldives" }, { c: "+223", l: "Mali" },
  { c: "+356", l: "Malta" }, { c: "+222", l: "Mauritania" }, { c: "+230", l: "Mauritius" },
  { c: "+52", l: "Mexico" }, { c: "+373", l: "Moldova" }, { c: "+377", l: "Monaco" },
  { c: "+976", l: "Mongolia" }, { c: "+382", l: "Montenegro" }, { c: "+212", l: "Morocco" },
  { c: "+258", l: "Mozambique" }, { c: "+95", l: "Myanmar" }, { c: "+264", l: "Namibia" },
  { c: "+977", l: "Nepal" }, { c: "+31", l: "Netherlands" }, { c: "+64", l: "New Zealand" },
  { c: "+505", l: "Nicaragua" }, { c: "+227", l: "Niger" }, { c: "+234", l: "Nigeria" },
  { c: "+389", l: "North Macedonia" }, { c: "+47", l: "Norway" }, { c: "+968", l: "Oman" },
  { c: "+92", l: "Pakistan" }, { c: "+970", l: "Palestine" }, { c: "+507", l: "Panama" },
  { c: "+675", l: "Papua New Guinea" }, { c: "+595", l: "Paraguay" }, { c: "+51", l: "Peru" },
  { c: "+63", l: "Philippines" }, { c: "+48", l: "Poland" }, { c: "+351", l: "Portugal" },
  { c: "+974", l: "Qatar" }, { c: "+40", l: "Romania" }, { c: "+7", l: "Russia" },
  { c: "+250", l: "Rwanda" }, { c: "+966", l: "Saudi Arabia" }, { c: "+221", l: "Senegal" },
  { c: "+381", l: "Serbia" }, { c: "+248", l: "Seychelles" }, { c: "+232", l: "Sierra Leone" },
  { c: "+65", l: "Singapore" }, { c: "+421", l: "Slovakia" }, { c: "+386", l: "Slovenia" },
  { c: "+252", l: "Somalia" }, { c: "+27", l: "South Africa" }, { c: "+82", l: "South Korea" },
  { c: "+34", l: "Spain" }, { c: "+94", l: "Sri Lanka" }, { c: "+249", l: "Sudan" },
  { c: "+597", l: "Suriname" }, { c: "+46", l: "Sweden" }, { c: "+41", l: "Switzerland" },
  { c: "+963", l: "Syria" }, { c: "+886", l: "Taiwan" }, { c: "+992", l: "Tajikistan" },
  { c: "+255", l: "Tanzania" }, { c: "+66", l: "Thailand" }, { c: "+228", l: "Togo" },
  { c: "+1", l: "Trinidad & Tobago" }, { c: "+216", l: "Tunisia" }, { c: "+90", l: "Turkey" },
  { c: "+993", l: "Turkmenistan" }, { c: "+256", l: "Uganda" }, { c: "+380", l: "Ukraine" },
  { c: "+971", l: "United Arab Emirates" }, { c: "+44", l: "United Kingdom" }, { c: "+1", l: "United States" },
  { c: "+598", l: "Uruguay" }, { c: "+998", l: "Uzbekistan" }, { c: "+58", l: "Venezuela" },
  { c: "+84", l: "Vietnam" }, { c: "+967", l: "Yemen" }, { c: "+260", l: "Zambia" },
  { c: "+263", l: "Zimbabwe" },
];

export default function PhoneInput({ testid, required, onChange }) {
  const [code, setCode] = useState("+354");
  const [num, setNum] = useState("");

  const update = (c, n) => {
    setCode(c);
    setNum(n);
    onChange(n.trim() ? `${c} ${n.trim()}` : "");
  };

  return (
    <div className="flex gap-3">
      <select
        data-testid={testid ? `${testid}-code` : undefined}
        value={code}
        onChange={(e) => update(e.target.value, num)}
        className="bg-transparent border-b border-white/20 py-3 pr-2 text-white focus:outline-none focus:border-white transition-colors w-[110px] shrink-0"
      >
        <optgroup label="Popular">
          {POPULAR.map((o, i) => (
            <option key={`p-${o.c}-${i}`} value={o.c} className="bg-[#0C0C0E] text-white">
              {o.c} {o.l}
            </option>
          ))}
        </optgroup>
        <optgroup label="All countries">
          {ALL.map((o, i) => (
            <option key={`a-${o.c}-${i}`} value={o.c} className="bg-[#0C0C0E] text-white">
              {o.c} {o.l}
            </option>
          ))}
        </optgroup>
      </select>
      <input
        data-testid={testid}
        required={required}
        inputMode="tel"
        value={num}
        onChange={(e) => update(code, e.target.value)}
        placeholder="Phone number"
        className="flex-1 bg-transparent border-b border-white/20 px-0 py-3 text-white focus:outline-none focus:border-white transition-colors w-full placeholder:text-gray-600"
      />
    </div>
  );
}
